import { combineReducers } from 'redux';
import wamp from './wamp';
import auth from './auth';

const reducers = combineReducers({
  auth,
  wamp,
});

export default reducers;
